/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import AddDocsModalPresenter from './AddDocsModalPresenter';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import DTOAddDocsModal from './DTOAddDocsModal';
import { documentService } from '../../../../api/services/documentService';
import {
  setEmployeeActiveDocs,
  setEmployeeActiveDocsLoader,
} from '../../../../infra/aggregates/myProfile/DocumentAggregates/getActiveEmpDocsSlice';
import { toast } from 'react-hot-toast';
import {
  setEmployeeExpiredDocs,
  setEmployeeExpiredDocsLoader,
} from '../../../../infra/aggregates/myProfile/DocumentAggregates/getExpiredEmpDocsSlice';
import { useTranslation } from 'react-i18next';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const AddDocsModalController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const { i18n } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);
  const store_ActiveDocuments: any = useAppSelector(
    (state) => state.getActiveEmpDocsSlice.empDocsData,
  );
  const store_ExpiredDocuments: any = useAppSelector(
    (state) => state.getExpiredEmpDocsSlice.empExpDocsData,
  );
  const [EmpDocTypes, setEmpDocTypes] = useState<[]>([]);
  const [countries, setCountries] = useState<[]>([]);

  const dispatch = useAppDispatch();
  const getData = (data: any) => {
    addingEmpDocs(data);
  };

  async function callBack(data: []) {
    setCountries(data);
  }
  async function callBackEmptypes(data: []) {
    setEmpDocTypes(data);
  }
  async function addingEmpDocs(addEmpDocs: any) {
    let isFormValid = true;

    if (
      !selector ||
      !addEmpDocs.documentTypeId ||
      !addEmpDocs.countryName ||
      !addEmpDocs.file
    ) {
      isFormValid = false;
    }

    if (isFormValid) {
      const empId: any = selector.emp_id;
      const CompanyID: any = selector.company_id;

      const formData = new FormData();

      formData.append('empId', empId);
      formData.append('CompanyID', CompanyID);
      formData.append('document_type_id', addEmpDocs.documentTypeId);
      formData.append('issue_country', addEmpDocs.countryName);
      formData.append('issue_date', addEmpDocs.issueDate);
      if (!addEmpDocs?.showExpiryDate) {
        formData.append('validity_date', addEmpDocs.expiredDate);
      }

      formData.append('identifier_number', addEmpDocs.identifierNo);
      formData.append('remarks', addEmpDocs.remarks);
      if (addEmpDocs?.newattachement) {
        formData.append('documents[]', addEmpDocs.file);
      }
      formData.append('full_path', 'true');

      if (addEmpDocs?.showReferenceNo) {
        formData.append('reference_number', addEmpDocs?.referenceNo);
      }

      if (addEmpDocs?.showAddReferenceNo) {
        formData.append(
          'additional_reference_number',
          addEmpDocs?.addReferenceNo,
        );
      }

      const response: any = await documentService.addEmpDocs(formData);

      if (response.response == 'success') {
        if (i18n.language == 'ar') {
          refreshData();
        } else {
          if (response?.data[0]?.expired == false) {
            const tempActiveDocs = [...store_ActiveDocuments];
            tempActiveDocs.push(response?.data[0]);
            dispatch(setEmployeeActiveDocs(tempActiveDocs));
          } else if (response?.data[0]?.expired) {
            const tempExpiredDocs = [...store_ExpiredDocuments];
            tempExpiredDocs.push(response?.data[0]);
            dispatch(setEmployeeExpiredDocs(tempExpiredDocs));
          }

          toast.success(trans('Added Successfully'));
        }
        closeModal();
      }
    } else {
      toast.error(trans('Please fill the missing fields!'));
    }
  }

  const refreshData = async () => {
    dispatch(setEmployeeExpiredDocsLoader(true));
    const response: any = await documentService.getExpiredDocs(
      selector.company_id,
      selector.emp_id,
    );

    if (response.response == 'success') {
      const empExpDocsData: any = response?.data;

      dispatch(setEmployeeExpiredDocs(empExpDocsData));
      /* Passing Props to Controller */

      dispatch(setEmployeeExpiredDocsLoader(false));
    } else {
      dispatch(setEmployeeExpiredDocsLoader(false));
      return;
    }
    dispatch(setEmployeeActiveDocsLoader(true));

    const resp: any = await documentService.getActiveDocs(
      selector.company_id,
      selector.emp_id,
    );

    if (resp.response == 'success') {
      const empDocsData: any = resp?.data;

      dispatch(setEmployeeActiveDocs(empDocsData));
      /* Passing Props to Controller */

      dispatch(setEmployeeActiveDocsLoader(false));
    } else {
      dispatch(setEmployeeActiveDocsLoader(false));
      return;
    }
  };
  return (
    <>
      <>
        <DTOAddDocsModal
          setAllCountries={callBack}
          setAllEmpDocsType={callBackEmptypes}
        />
        <AddDocsModalPresenter
          callBackGetData={getData}
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          allEmpDocTypes={EmpDocTypes}
          allCountires={countries}
          trans={trans}
        />
      </>
    </>
  );
};
export default AddDocsModalController;
